import { computed } from 'vue'
import { useRoute, useRouter } from 'vue-router'

import { NotificationCenterTab, notificationCenterTabFromQuery } from './notificationCenterTabFromQuery'

export const useRouterQueryNotificationCenterTab = () => {
  const route = useRoute()
  const router = useRouter()

  const tab = computed(() => notificationCenterTabFromQuery(route.query))

  function setTab(value: NotificationCenterTab) {
    router.push({ query: { ...route.query, tab: value !== NotificationCenterTab.ALL ? value : undefined } })
  }

  return { tab, setTab }
}
